import React from 'react';
import { useMutation } from '@tanstack/react-query';
import services from 'services/services';

/** @typedef {import('services/services').DisableDoubleOptInResponseData} DisableDoubleOptInResponseData */

/** @typedef {Omit<import('@tanstack/react-query').UseMutationOptions<DisableDoubleOptInResponseData, Error, null, unknown>, 'mutationKey' | 'mutationFn'>} UseDisableDoubleOptInMutationOptions */

/**
 * Disable double opt-in by changing account setting.
 *
 * @param {UseDisableDoubleOptInMutationOptions} [options={}]
 */
export const useDisableDoubleOptInMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['disable-double-opt-in'],
        mutationFn: () => services.disableDoubleOptIn()
    });
};
